import { register } from "swiper/swiper-element-bundle.mjs";

import * as nav from "./modules/navigation.js";
import * as swiper from "./modules/swiper.js";
import animateOnScroll from "./modules/observer.js";

// Register Swiper custom elements
register();

// Stop transitions before page has loaded
window.addEventListener("load", function () {
  $("body").removeClass("preload");
  $("header, main, footer").removeClass("opacity-0");
});

// Page transition
let ignoreUnload = false;

$("a[href^=mailto]").on("click", function () {
  ignoreUnload = true;
});

window.addEventListener("beforeunload", function () {
  if (!ignoreUnload) {
    $("header, main, footer").addClass("opacity-0");
  }

  ignoreUnload = false;
});

// UI
$(".open-newsletter").click(function (e) {
  e.preventDefault();

  $(".newsletter > div").addClass("header-animate");
  $(".newsletter").removeClass("hidden");
});

$(".newsletter").click(function (e) {
  if (e.target !== e.currentTarget) {
    return;
  }

  $(".newsletter").addClass("hidden");
});

// Anchors
$("a[href^='#']").on("click", function (e) {
  e.preventDefault();

  const scrollTop = $($(this).attr("href")).position().top - 64;

  $("html, body").animate({ scrollTop });
});
